import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { PaginatorComponent } from '@app/shared/components/paginator/paginator.component';
import { SearchWidgetComponent } from '@app/shared/components/search-widget/search-widget.component';
import { ToastService } from '@teorema/patron';
import { AccessTypeLabel } from 'src/app/models/bw-user.model';
import { FilterField } from 'src/app/models/filter-field.model';
import { FindOptions } from 'src/app/models/find-options.model';
import { Profile } from 'src/app/models/user.model';
import { ProfileService, utils } from 'src/app/shared';

@Component({
  templateUrl: './profiles.component.html',
  styleUrls: ['./profiles.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProfilesComponent {
  profiles: Profile[] = [];
  loading: boolean = false;
  currentPage = 1;
  lastPage = 1;
  totalItems = 0;
  findOptions: FindOptions = {
    orderBy: 'name',
    storageKey: 'profiles-find-options',
    withs: ['modules'],
    q: '',
    filters: [
      new FilterField({
        name: 'type',
        label: 'Tipo',
        type: 'select',
        options: [
          { label: AccessTypeLabel.User, value: 'U' },
          { label: AccessTypeLabel.Customer, value: 'C' },
          { label: AccessTypeLabel.Supplier, value: 'S' },
        ],
      }),
    ],
  };

  @ViewChild('paginator') paginator!: PaginatorComponent;
  @ViewChild('searchWidget') searchWidget!: SearchWidgetComponent;

  patronUtils = utils;

  constructor(
    private profileService: ProfileService,
    private toastService: ToastService,
    private router: Router
  ) {}

  async findProfiles() {
    this.loading = true;
    let response = await this.profileService.findAll(this.findOptions).catch(err => {
      if (!err?.messageShown)
        this.toastService.show({ color: 'error', message: 'Houve um erro ao carregar os dados' });
    });

    if (response?.data) {
      this.profiles = response.data;
    }

    if (response?.total != null && response?.total >= 0) {
      this.totalItems = response.total;
    }

    this.loading = false;
  }

  async paginate(findOptions?: FindOptions) {
    if (findOptions) this.findOptions = { ...this.findOptions, ...findOptions };

    if (this.findOptions?.q) {
      this.searchWidget.updateValue(this.findOptions.q);
    }

    await this.findProfiles();
  }

  onSearch(searchText?: string) {
    if (searchText != this.findOptions.q) {
      this.findOptions.q = searchText;
      this.goToFirstPage();
    }
  }

  goToFirstPage() {
    this.paginate({ page: 1 });
    this.paginator.component.first = 0;
  }

  onRowClicked(profile: Profile) {
    this.router.navigate([`/perfis/${profile.id}`]);
  }

  isEnableNewProfile() {
    return utils.isUser() && utils.checkAccess(['Users'], true, true).result;
  }

  async toggleDefault(event: Event, profile: Profile, index: number) {
    event.stopPropagation();
    this.loading = true;
    const response: any = await this.profileService
      .save({ ...profile })
      .finally(() => {
        this.loading = false;
      })
      .catch(() => {
        this.toastService.show({
          color: 'error',
          message: `Houve um erro ao ${profile.default ? 'ativar' : 'desativar'} o perfil ${profile.name} como padrão.`,
        });
        this.profiles[index] = { ...profile, default: !profile.default };
      });

    if (response?.id) {
      this.profiles[index] = response;
      this.toastService.show({
        color: 'success',
        message: `O perfil ${profile.name} foi ${profile.default ? 'ativado' : 'desativado'} como padrão.`,
      });
    }
  }
}
